import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import "../styles/ServiceDetail.css";

// Import images for services
import office from "../assets/office.jpg";
import library from "../assets/work.jpg";
import officeCeiling from "../assets/office_ceiling.jpg";
import publicImage from "../assets/public.jpg";
import background from "../assets/background.jpg";

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const history = useHistory();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const serviceData = {
    1: {
      id: 1,
      image: office,
      title: "Elegant POP Sculpted Ceiling",
     // description: "Gracefully sculpted POP ceilings that elevate every room with timeless elegance and modern finesse.",
      description: "A sleek, secondary ceiling crafted from Plaster of Paris that enhances interiors with clean lines, custom shapes, and seamless lighting integration. It elegantly conceals wiring and ducting, enhances acoustics, and enables modern lighting like recessed and cove fixtures for a refined, contemporary look. Ideal for living rooms, bedrooms, and offices, it’s lightweight, paint-ready, and tailored on-site to suit any interior style.",
      details: [
        //"A sleek, secondary ceiling crafted from Plaster of Paris that enhances interiors with clean lines, custom shapes, and seamless lighting integration. It elegantly conceals wiring and ducting, enhances acoustics, and enables modern lighting like recessed and cove fixtures for a refined, contemporary look. Ideal for living rooms, bedrooms, and offices, it’s lightweight, paint-ready, and tailored on-site to suit any interior style.",
        "POP false ceiling",
        "POP Wall Plaster",
      ]
    },
    2: {
      id: 2,
      image: library,
      title: "Precision Gypsum Panel Ceiling",
      //description: "Precision‑cut gypsum panels for seamless ceilings that enhance acoustics, lighting, and modern aesthetics.",
      description: "Upgrade interiors with a sleek, durable, and low-maintenance ceiling system made from high-quality gypsum boards fixed on a sturdy metal framework for a smooth, modern finish. Ideal for homes and offices, it offers excellent fire resistance, sound insulation, and thermal comfort while neatly concealing wiring, pipes, and ducting for a clean, clutter-free look. Lightweight yet robust, it supports recessed and cove lighting, resists sagging and cracks, and provides a perfectly paint-ready surface tailored to any design style.",
      details: [
        "Gypsum Board False Ceiling",
        "Gypsum Board Designer False Ceiling",
        "Gypsum Board Plain False Ceiling",
        "Gypsum Board Partitions"
      ]
    },
    3: {
      id: 3,
      image: officeCeiling,
      title: "Modern Louvered Wall Panels",
      description: "Transform ceilings with stylish, modular wall-panel–style finishes that deliver a premium look, fast installation, and long-lasting performance. Designed to conceal wiring and ducting, these panels enhance acoustics and energy efficiency while creating a clean, seamless surface ideal for homes and commercial spaces. Lightweight, low-maintenance, and moisture-resistant options (such as PVC, laminate, and engineered composites) support recessed and cove lighting, resist stains and termites, and provide a ready-to-use, wipe-clean finish for modern interiors.",
      details: [
        "PVC Panels False Ceiling",
        "Louvers Wall Panels",
        "Charcoal Wall Panels",
        "Exterior Façade Ceiling & Wall Panels",
      ]
    },
    4: {
      id: 4,
      image: publicImage,
      title: "AquaShield Moisture-Guard Ceiling",
      description: "Deliver superior safety and durability with ceilings engineered to resist humidity and slow flame spread for enhanced protection. Built with specialized boards and panels, this system helps prevent warping, mold, and mildew while meeting stringent fire-performance standards for safer interiors. Ideal for kitchens, bathrooms, corridors, offices, and commercial spaces, it conceals services, supports recessed and cove lighting, improves acoustics, and provides a smooth, low-maintenance, paint-ready finish.",
      details: [
        "AquaShield Moisture-Guard Ceiling",
         "Fire Line Board False Ceiling",
         "Cement Fiber Board False Ceiling",
         "Cement Fiber Board Partitions"
      ]
    },
    5: {
      id: 5,
      image: background,
      title: "Laminated False Ceiling",
      description: "Elevate interiors with durable, pre-finished ceiling panels featuring a sleek laminate surface for a modern, low-maintenance look. Engineered over gypsum or composite cores with PVC/vinyl laminates, they offer moisture resistance, easy wipe-clean care, and superior stain protection while concealing wiring and ducting for a seamless finish. Ideal for homes, offices, retail, and hospitality, laminated false ceilings install quickly on grid frameworks, support recessed and cove lighting, and come in a wide range of textures, woodgrains, and matte or high-gloss designs for contemporary style.",
      details: [
        "2X2 Tiles PVC Laminated False Ceiling",
        "2X2 Tiles Mineral Fiber Ceiling",
        "2X2 Tiles Cement Fiber Ceiling",
        "2X2 Tiles GRG False Ceiling",
        "2X2 Tiles Eco Block Ceiling",
        "2X2 Tiles Metal Ceiling"
      ]
    }
  };

  const service = serviceData[serviceId];

  if (!service) {
    return (
      <div className="service-detail-container">
        <div className="error-message">
          <h2>Service not found</h2>
          <button onClick={() => history.push('/')} className="back-button">
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="service-detail-container">
      <div className="service-detail-content">
        {/* Back Button */}
        <button onClick={() => history.push('/')} className="back-button">
          ← Back to Home
        </button>

        {/* Service Image */}
        <div className="service-image-container">
          <img src={service.image} alt={service.title} className="service-image" />
        </div>

        {/* Service Details */}
        <div className="service-details">
          <h1 className="service-title">{service.title}</h1>
          <p className="service-description">{service.description}</p>
          
          <div className="service-features">
            <h3>What We Offer:</h3>
            <ul className="features-list">
              {service.details.map((detail, index) => (
                <li key={index} className="feature-item">
                  <span className="bullet">•</span>
                  {detail}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail;
